import getScenarioStore from '../selectors/getScenarioStore';
import { exitSearch, setIsSuggestionsDropdownVisible } from '../actions/publicActions';
import { onEscapePressedSearchInput } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';

orchestrator(onEscapePressedSearchInput, actionMessage => {
    const scenarioId = actionMessage.scenarioId;
    const store = getScenarioStore(scenarioId);

    /**
     * If suggestions dropdown is visible hide it. If it's already hidden, then
     * exit search.
     */
    if (store.isSuggestionsDropdownVisible) {
        setIsSuggestionsDropdownVisible(false, scenarioId);
    } else {
        exitSearch('Escape', scenarioId);
    }
});
